import {Routes, Route} from 'react-router-dom'
import Main from './main';
// import Nasa from './projects/nasa_project/nasa';

function App() {
  

  return (
    <div className="App">

        <Routes>
          <Route path='/' element={<Main/>}/>
          {/* <Route path='/nasa' element={<Nasa/>}/> */}
        </Routes>

    </div>
  );
}

export default App;
